import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-center black-title text-xl font-bold" }, "Send to")
], -1)
const _hoisted_3 = { class: "flex flex-col space-y-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "black-title" }, "Account ID", -1)
const _hoisted_5 = { class: "flex flex-col space-y-1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "black-title" }, "Address", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "black-title" }, "Frequent Contacts"),
  /*#__PURE__*/_createElementVNode("div", { class: "border-card p-1 rounded-xl" })
], -1)
const _hoisted_8 = { class: "flex justify-around" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    title: "",
    placement: _ctx.placement,
    visible: _ctx.visible,
    height: "75%",
    destroyOnClose: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_a_input, {
            class: "a-input",
            value: _ctx.accountIdValue,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.accountIdValue) = $event))
          }, null, 8, ["value"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_a_input, {
            class: "a-input",
            value: _ctx.addressValue,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addressValue) = $event))
          }, null, 8, ["value"])
        ]),
        _withDirectives(_createVNode(_component_a_alert, {
          message: "Error Text",
          type: "error"
        }, null, 512), [
          [_vShow, _ctx.showErr]
        ]),
        _createVNode(_component_a_checkbox, {
          checked: _ctx.checked,
          "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.checked) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Add to Frequent Contacts")
          ]),
          _: 1
        }, 8, ["checked"]),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            class: "cancel-button cursor-pointer p-2 w-32 text-center rounded-full",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
          }, "Cancel"),
          _createElementVNode("span", {
            class: "next-button cursor-pointer p-2 w-32 text-center rounded-full",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleNextClick && _ctx.handleNextClick(...args)))
          }, "Next")
        ])
      ])
    ]),
    _: 1
  }, 8, ["placement", "visible"]))
}